// @file Network requests related to Whiteboard Access Token from sandbox
/* eslint-disable no-return-await, no-template-curly-in-string */
import type { VersionedFetchOptions } from '@@/surface/api/fetchable_object'
import FetchableObject from '@@/surface/api/fetchable_object'
import { fetchJson } from '@@/surface/api_fetch'
import type { JsonAPIResponse } from '@padlet/arvo'
import { HTTPMethod } from '@padlet/fetch'

interface WhiteboardAccessToken {
  token: string
}

class WhiteboardAccessTokenApi extends FetchableObject {
  public static get url(): string {
    return `/api/\${ apiVersion }/walls/\${ wallHashid }/whiteboard/access-token`
  }

  public static async fetch(
    wallHashid: string,
    fetchOptions: VersionedFetchOptions = { apiVersion: 9 },
  ): Promise<string> {
    const { apiVersion, ...otherFetchOptions } = fetchOptions
    const response: JsonAPIResponse<WhiteboardAccessToken> = await fetchJson(
      this.buildUrl(this.url, { wallHashid, apiVersion }),
      {
        method: HTTPMethod.get,
        ...otherFetchOptions,
      },
    )
    const token = Array.isArray(response.data) ? response.data[0]?.attributes.token : response.data?.attributes.token
    if (token == null) throw new Error('Invalid response from server')
    return token
  }
}

export { WhiteboardAccessTokenApi }
